import {encode as base64_encode } from 'base-64';
import { postApi,baseURL } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';
import { message } from "antd";
import config from "../config";

class MaintenanceFleetReportStore {
  maintenanceReportStore=[]
  maintenanceService=[]
  rootStore
  total = 0;
  constructor(rootStore) {
    makeObservable(this, {
      maintenanceReportStore: observable,
      loadData: action,
      getServiceData:action,
      total: observable,
    });
    this.rootStore = rootStore;

  }



  async loadData({companyId,vehicleId,offset,limit,serviceId}) {
    // console.log("vehicle list")
    var postData ={"companyId":companyId,"vehicleId":vehicleId,"serviceId":serviceId,"offset":offset,"limit":limit,"page":1}

    if(config.pythonReport === 1){
          var response = await postApi.getClient('report').post("/miscellaneous_report/maintenanceReport", postData);
    }else{
          const base64Input = await base64_encode(JSON.stringify(postData));
          response = await postApi.getClient().post("index.php?c=vehicle&a=maintenancereport", "postData="+base64Input);
    }
   
  //  console.log(response?.data?.data?.maintenancereport)
     this.maintenanceReportStore =response?.data?.data?.maintenancereport
     this.total = parseInt(response?.data?.data?.TotalCount);

  }

  async getServiceData() {

    // console.log("vehicle list")
    var postData = {}
    var response = await postApi.getClient("NodeCoreUrl").get("newmaintenance/getServiceTypes", {
        params: postData,
    });
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi.getClient('phpurl').post("index.php?c=maintenance&a=getService", "postData="+base64Input);
   
    // console.log(response, "post")
    this.maintenanceService =response?.data?.data
    return response?.data?.data
    
  }


  async exportExcel(getData) {
    // console.log("getData", getData);
    if(config.pythonReport === 1){    
      try {
          var response = await postApi.getClient("report").post("/miscellaneous_report/maintenanceReport/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Maintenance Fleet Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportmaintenanceexcel&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId +
          "&vid=" +
          getData.vehicleId +
        
          "&colList=" +
          getData.colList +
          "&sid=" +
          getData.sid +
          "&language=" +
          lang;
    }
  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){    
        try {
  
          var response = await postApi.getClient("report").post("/miscellaneous_report/maintenanceReport/download/pdf", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: 'application/pdf'
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Maintenance Fleet Report.pdf";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        
        } catch (error) {
            message.error("Failed to download the report. Please try again.")
        }
  
    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportmaintenancepdf&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId +
          "&vid=" +
          getData.vehicleId +
          // "&int="+
          // getData.interval+
          // "&fD=" +
          // getData.fromDate +
          // "&tD=" +
          // getData.toDate +
          "&colList=" +
          getData.colList +
          "&sid=" +
          getData.sid +
          "&language=" +
          lang;
    }
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportmaintenancecsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      // "&fD=" +
      // getData.fromDate +
      // "&tD=" +
      // getData.toDate +
      "&colList=" +
      getData.colList +
      "&sid=" +
      getData.sid +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportmaintenancexml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      // "&fD=" +
      // getData.fromDate +
      // "&tD=" +
      // getData.toDate +
      "&colList=" +
      getData.colList +
      "&sid=" +
      getData.sid +
      "&language=" +
      lang;
  }

  
  

}

export default MaintenanceFleetReportStore;